import { CREATE_ALERT } from 'actions/actionTypes';
import { removeAlert } from 'actions';
import { TOAST_VISIBILITY_DURATION } from 'constants/flowControlConstants';
import { get } from 'lodash';

const SYSTEM_FINGERPRINT_PREFIX = 'system_';

export const notifications = store => next => action => {
  switch (action.type) {
    case CREATE_ALERT:
    {
      const displayDuration = get(action, 'payload.duration', TOAST_VISIBILITY_DURATION);
      // fingerprint let's devs control how to use the alert (how to display/remove it)
      const { fingerprint: passedFingerprint } = action.meta;
      // if no fingerprint is provided initially the system will define one and control it's removal
      const alertAction = {
        ...action,
        meta: {
          ...action.meta,
          fingerprint: passedFingerprint || `${SYSTEM_FINGERPRINT_PREFIX}${new Date().toISOString()}`
        }
      };

      if (!passedFingerprint) {
        setTimeout(() => {
          store.dispatch(removeAlert({
            meta: {
              fingerprint: alertAction.meta.fingerprint
            }
          }));
        }, displayDuration);
      }
      next(alertAction);
      break;
    }
    default:
      next(action);
  }
};

export default notifications;
